export default function isNumber(value) {
    return typeof value === "number";
}
//# sourceMappingURL=is-number.js.map



//////////////////
// WEBPACK FOOTER
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/~/@telerik/kendo-intl/dist/es/common/is-number.js
// module id = ../../../../@telerik/kendo-intl/dist/es/common/is-number.js
// module chunks = 3